import { Action } from './action';

function condition() {
  return true;
}

function escHanlder(stageContext) {
  const { interactive } = stageContext.providers;
  interactive.cursor.setById('');
  interactive.insertNode = null;
  interactive.moveMode = '';
  interactive.selectMode = '';
  stageContext.api.clearSelect();
}

export const escAction = new Action({
  name: 'Exit',
  handler: escHanlder,
  shortcuts: 'ESCAPE',
  condition: condition,
});
